import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';
import { bootstrapYandexMetrika } from './lib/analytics/yandexMetrika';
import './styles/global.scss';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

bootstrapYandexMetrika();

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
